import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Password } from 'primereact/password';
import { InputText } from 'primereact/inputtext';

const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const NoLoginDialog = forwardRef(({ onLoginChange, initialPhone = '', initialEmail = '' }, ref) => {
    const [newPassword, setNewPassword] = useState('');
    const [phone, setPhone] = useState(initialPhone || '');
    const [email, setEmail] = useState(initialEmail || '');
    const [errors, setErrors] = useState({});

    const handleChange = (e, type) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');

        if (type === 'Phone') {
            setPhone(numericValue);
            setErrors((prev) => ({ ...prev, phone: '' }));
        } else if (type === 'Email') {
            const maxLength = 50;
            if (value.length <= maxLength) {
                setEmail(value);
            }
            setErrors((prev) => ({ ...prev, email: '' }));
        }
    };

    useEffect(() => {
        if (onLoginChange) {
            onLoginChange(phone, email, newPassword);
        }
    }, [newPassword, phone, email]);

    // Same phone/email rules as Add/Update Student Master, shown as inline
    // errors under each field (toasts render behind the modal and aren't seen).
    useImperativeHandle(ref, () => ({
        validate: () => {
            const nextErrors = {};
            const ph = (phone || '').trim();
            const em = (email || '').trim();

            if (!ph) {
                nextErrors.phone = 'Phone no is required';
            } else if (ph.length !== 10) {
                nextErrors.phone = 'Please enter a valid 10-digit phone number';
            }

            if (!em) {
                nextErrors.email = 'Email is required';
            } else if (!emailPattern.test(em)) {
                nextErrors.email = 'Please enter a valid email address';
            }

            if (!newPassword) {
                nextErrors.newPassword = 'Password is required';
            }

            setErrors(nextErrors);
            return Object.keys(nextErrors).length === 0;
        },
    }));

    return (
        <div className="p-d-flex p-flex-column">
            <div className="p-col-12 p-md-4 p-pt-2">
                <div className="">
                    <label htmlFor="phone">Phone No.<span style={{ color: "red" }}>*</span></label>
                    <InputText
                        id="phone"
                        type="text"
                        value={phone}
                        maxLength={10}
                        onChange={(e) => handleChange(e, 'Phone')}
                    />
                    <span className="error-msg" style={{ color: 'red' }}>
                        {errors.phone ? errors.phone : null}
                    </span>
                </div>
            </div>
            <div className="p-col-12 p-md-4 p-pt-2">
                <div className="">
                    <label htmlFor="email">Email<span style={{ color: "red" }}>*</span></label>
                    <InputText
                        id="email"
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => handleChange(e, 'Email')}
                    />
                    <span className="error-msg" style={{ color: 'red' }}>
                        {errors.email ? errors.email : null}
                    </span>
                </div>
            </div>
            <div className="p-col-12 p-md-4 p-pt-2">
                <div className="">
                    <label htmlFor="newPassword" >Password<span style={{ color: "red" }}>*</span></label>
                    <Password
                        id="newPassword"
                        value={newPassword}
                        onChange={(e) => {
                            setNewPassword(e.target.value);
                            setErrors((prev) => ({ ...prev, newPassword: '' }));
                        }}
                        toggleMask
                        feedback={false}
                        maxLength={20}
                        className="p-mt-2 p-w-100"
                    />
                    <span className="error-msg" style={{ color: 'red' }}>
                        {errors.newPassword ? errors.newPassword : null}
                    </span>
                </div>
            </div>
        </div>
    );
});

export default NoLoginDialog;
